/*
 * File: d:\projects\AutoFiFront\src\Content\Faq\Faq_financement.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday March 29th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 21st April 2023 04:32:48
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from 'react';
import styles from "Content/Faq/Faq_financement.module.css";
import "Content/Faq/Faq_financement.css";
import FaqBox from 'Content/Faq/FaqBox/FaqBox';

function FaqFinancement (_: any) {
    const partI = [
        {
            question:"partOneQuestOne",
            response:["partOneRespOne"]
        },
        {
            question:"partOneQuestTwo",
            response:["partOneRespTwo"]
        },
        {
            question:"partOneQuestThree",
            response:["partOneRespThreeParaOne","partOneRespThreeParaTwo"]
        }
    ];
    const partII = [
        {
            question:"partTwoQuestOne",
            response:["partTwoRespOne"]
        },
        {
            question:"partTwoQuestTwo",
            response:["partTwoRespTwo"]
        }
    ];
    const partIII = [
        {
            question:"partThreeQuestOne",
            response:["partThreeRespOneParaOne","partThreeRespOneParaTwo","partThreeRespOneParaThree","partThreeRespOneParaFour","partThreeRespOneParaFive","partThreeRespOneParaSix"]
        },
        {
            question:"partThreeQuestTwo",
            response:["partThreeRespTwoParaOne","partThreeRespTwoParaTwo","partThreeRespTwoParaThree","partThreeRespTwoParaFour","partThreeRespTwoParaFive"]
        }
    ];
    const partIV = [
        {
            question:"partFourQuestOne",
            response:["partFourRespOneParaOne","partFourRespOneParaTwo","partFourRespOneParaThree"]
        }
    ];

    return (
        <React.Fragment>
            <div className={`${styles.faqHolder}`}>
                <FaqBox title={'titleI'} part={partI} />
                <FaqBox title={'titleII'} part={partII} />
                <FaqBox title={'titleIII'} part={partIII} />
                <FaqBox title={'titleIV'} part={partIV} />
            </div>
        </React.Fragment>
    );
}

export default FaqFinancement;
